<template>
  <div class="p_demand_plan">
    <div class="p_plan_content">
        <div class="p_plan_list">
            <div class="p_plan_item">
                <div class="p_plan_title">报名二维码:</div>
                <div class="p_plan_right">
                    <el-popover placement="bottom" width="200" trigger="click">
                        <div class="qrcode_box">
                            <img :src="canvasImg" class="qrcode_img02" />
                            <!-- <a :href="canvasImg" download="企业码" target="_blank">点击下载</a> -->
                        </div>
                        <el-button slot="reference" class="qcode_btn" type="text">
                            <img src="./../../../assets/images/qrcode.png"
                            class="qrcode_img01"
                            @click="cerateQCode"
                            />
                        </el-button>
                    </el-popover>
                    <!-- <span class="txt01" @click="repeatHandle">链接分享</span> -->
                </div>
            </div>
        </div>
        <div class="p_plan_line">
            <div class="p_plan_item" v-if="postQuery.jobType">
                <div class="p_plan_title">招聘岗位类别:</div>
                <div class="p_plan_right">{{postQuery.jobType}}</div>
            </div>
            <div class="p_plan_item" v-if="postQuery.customerJobName">
                <div class="p_plan_title">客户企业岗位名称:</div>
                <div class="p_plan_right">{{postQuery.customerJobName}}</div>
            </div>
        </div>
        <!-- 缺口记录 -->
        <div class="p_plan_form">
            <p class="p_dtl_txt">缺口记录:</p>
            <div class="plan_form_list" v-if="gapList.length > 0">
                <div class="p_plan_record" v-for="(item,index) in gapList" :key="index">
                    <i class="item_icon el-icon-info"></i>
                    <span>{{index+1}}.</span>
                    <span v-if="item.updateTime">更新时间:{{item.updateTime?item.updateTime.replace('T',' '):''}}；</span>
                    <span v-if="item.StrgapNum">缺口数量:{{item.StrgapNum}}；</span>
                    <span v-if="item.StrgapCont">缺口描述:{{item.StrgapCont}}；</span>
                    <span v-if="(!isNull(gapList[0].StrEnclosure))&&(index==0)">附件:{{gapList[0].StrEnclosureName}}。</span>
                    <span v-if="(!isNull(gapList[0].StrEnclosure))&&(index==0)" @click="downloadFile(gapList[0].StrEnclosure)" class="d_txt">下载附件</span>
                </div>
            </div>
        </div>
        <div class="plan_form_list">
            <div class="p_plan_item">
                <div class="p_plan_title note_form">岗位发布有效期:</div>
                <div class="p_plan_right" v-if="!isLongCheck">
                    {{!this.isNull(recruitDate) ? recruitDate[0]+'至'+recruitDate[1] : ''}}
                </div>
            </div>
            <div class="p_plan_item" v-if="isLongCheck">
                <el-checkbox v-model="isLongCheck" disabled>岗位发布长期有效</el-checkbox>
            </div>
        </div>
        <p class="add_txt">
            <span v-if="postQuery.interviewAddress"><span class="txt06">面试地址：</span>{{provinceName+cityName+areaName+postQuery.interviewAddress}}</span>
            <!-- <i v-if="postQuery.interviewAddress" class="el-icon-location-information"></i> -->
            <span v-if="postQuery.interviewAddressUrl" class="txt07" @click="detailEnclosure">查看附件</span>
        </p>
        <p class="txt03" v-if="termUpdateTime"><span class="txt06">排期更新时间：</span>{{termUpdateTime}}</p>
        <div class="p_checkbox" v-if="isRepeatCheck">
            <p class="txt04">客户面试时间:</p>
            <el-checkbox v-model="isRepeatCheck" disabled>后面重复此排期</el-checkbox>
        </div>
        <div class="p_interview_box" v-loading="dateLoading">
            <!-- <div class="p_interview_left">
                <ul>
                    <li v-for="(item,index) in timeNodeList" :key="index">{{item}}</li>
                </ul>
            </div> -->
            
            <div class="p_interview_right plan_table">
                <el-table id="timetable" v-loading="tableLoading" :data="tableData" height="450" border class="date_table02" style="width:100%;" :header-cell-style="{background:'#545c64',color:'#fff'}" :highlight-current-row="false">
                    <el-table-column align="center" label="时间/日期" width="90px" fixed>
                        <template slot-scope="{row}">
                            <div class="date_table_txt">{{row.Strtimeslot}}</div>
                        </template>
                    </el-table-column>
                    <template v-for="(item,index) in tableTitle">
                        <el-table-column align="center" :label="item.Strdatename" :key="index" min-width="116px">
                            <template slot-scope="{row}">
                                <div class="term_cell" :class="[row[item.StrCloumid] == '1' ? 'cell_active' : 'cell_nonactive' ]">{{row[item.StrCloumid]}}</div>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <div class="p_plan_type">
            <div class="type_item">
                <div class="type01 type02"></div>
                <p>已选时段</p>
            </div>
            <div class="type_item">
                <div class="type01"></div>
                <p>未选时段</p>
            </div>
        </div>
        <!-- 分配招聘部门 -->
        <div class="p_plan_form p_plan_form03">
            <p class="p_dtl_txt">分配招聘部门详情:</p>
            <div class="plan_form_list">
                <el-table :data="depUserList" style="width: 100%" border>
                    <el-table-column prop="Strorganname" label="招聘部门" align="center">
                        <template slot-scope="{row}">
                            <span>{{ row.Strorganname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="StradviseruserNames" align="center" label="招聘人员" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                            <span>{{ row.StradviseruserNames}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="p_plan_btns">
            <el-button type="primary" @click="backHandle" size="small">返回</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import moment from 'moment';
export default {
  name: "recruitPlan",
  data() {
    return {
        imgPath: this.$store.state.EMP.imgPath,
        dateLoading:false,
        editId:'',
        // 岗位信息参数
        postQuery:{
            postId:'', // 岗位id
            ProjectId:'', // 项目id
            jobType:'', // 岗位类别
            customerJobName:'', // 企业客户岗位名称
            interviewAddress:'', // 面试地址
            interviewAddressUrl:'', // 面试地址详情附件
            lng:'', // 经纬
            lat:'' // 纬度
        },
        codeloading: false,
        canvasImg: './../../../assets/images/qrcode.png',
        planQuery:{
            GdrecpId: '', // 计划id
            Projectid: '', // 项目id
            Jobid: '', // 岗位ID 633240d3-8372-42c2-b546-b5f1584a4aac
            StrDateterm: '', // 招聘期限
            StrRemark: '', // 备注（目前无）
            GduserId: Cookies.get("userid-b"),       
            GduserName: '', // 登录人姓名
            StrIsredate:'', // 是否重复排期 是 否
            StrPlanstatus: '' // 计划状态 
        },
        // 排期参数
        termQuery:{
            dateend: '',
            datestart: '',
            datetype: '', // 是否重复排期
            gdrecpId: '' // 不传默认为新增
        },
        // 部门参数
        departQuery:{
          strorgancode:'',
          roletype:''
        },
        departMemberQuery: {
            keyword: '',
            strWorkState: '在职',
            currpage: 1,
            perpage: 100000
        },
        // 自定义 级联选择props
        props: { label: 'strorganname', value: 'strorgancode', children: 'children', checkStrictly: true },
        // 选中的招聘部门
        perDepartList:[],
        // 时间节点
        timeNodeList:[],
        // 时间日期列表数据
        dateTableList:[],
        tableData:[],
        tableTitle:[],
        tableLoading:false,
        // 招聘期限
        recruitDate:[],
        // 是否选中长期有效
        isLongCheck:true,
        // 是否后面重复此排期
        isRepeatCheck:false,
        // 缺口列表
        gapList:[],
        // 缺口参数
        gapQuery:{
            StrgapNum: '', // 缺口数量
            StrgapCont: '', // 缺口内容
            StrEnclosureName:'', // 附件名称
            StrEnclosure: '' // 缺口附件
        },
        // 排期参数
        scheduQuery:{
            Strtimeslot: '', // 时间段
            StrtimeDate: '', // 日期（如2022-11-18）
            StrIsCheck: '' // 是否选中（1或者0）
        },
        // 招聘部门和顾问参数
        depUserQuery:{
            Strorgancode: '', // 部门id
            StradviseruserId: '', // 招聘顾问id
            StradviseruserName: '', // 招聘顾问姓名
            StrIsshield: '否', // 是否需要屏蔽 是或者否
            checked: false,
            StrRemark: '' // 备注（目前无）
        },
        memberQuery:{
            StradviseruserId: '', // 招聘顾问id
            StradviseruserName: '', // 招聘顾问姓名
        },
        // 招聘部门列表
        depUserList:[],
        // 排期更新时间
        termUpdateTime:'',
        // 面试地址省份
        provinceName:'',
        // 面试地址城市
        cityName:'',
        // 面试地址地区
        areaName:'',
         // 生成二维码
      codeQuery:{
        Id:'', // 岗位ID
        pagepath:'pages/brochure/brochure', // 页面URL
        strLinkType:'A' //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      },
      loginRoleType:'',
      // 下载文件路径
        tablePath: this.$store.state.EMP.tablePath,
        docPath: this.$store.state.EMP.docPath
    }
  },
  created() {
    this.loginRoleType = localStorage.loginRoletype
    this.planQuery.GdrecpId = this.$route.query.GdrecpId
    this.termQuery.gdrecpId = this.$route.query.GdrecpId
    this.codeQuery.Id = this.$route.query.id
    // 获取岗位信息
    this.planQuery.Jobid = this.$route.query.id
    this.getPostInfo()
    // 查看招聘计划
    this.getRecruitDtl()
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event)
    },
    // 选择招聘顾问
    partnerSelChange(val){
        // console.log('partnerSelChange', val)
        this.memberQuery.StradviseruserId = val.value
        this.memberQuery.StradviseruserName = val.label
    },
    // 选择招聘部门
    perSectionChange(val){
        // console.log('perSectionChange', val)
        this.depUserQuery.Strorgancode = val[Number(val.length)-1]
        // this.getauthUserInfoByorgancode(val[Number(val.length)-1], localStorage.loginRoletype)
    },
    //生成企业二维码
    cerateQCode() {
      this.getCode()
    },
    // 获取二维码
    getCode(){
      this.codeloading = true;
      xz.getapplyjoobqrcodegenerated(this.loginRoleType,this.codeQuery).then(res => {
        // console.log('eee', res)
        if (res.status == 'ok') {
          let result = res.data
          this.canvasImg = this.imgPath + result
        }
        this.codeloading = false
        // console.log('getStateLists', this.data.status)
      })
    },
    // 返回
    backHandle(){
        this.$router.push({
            path: '/recruitDemand'
        })
    },
    // 获取招聘排期
    getTermData(){
        this.dateLoading = true
        xz.getRecruitPlanTerm(this.termQuery).then(res => {
            // console.log('ssss', res)
            if (!this.isNull(res)) {
                let resData = JSON.parse(res)
                // console.log('ssss', resData)
                this.termUpdateTime = resData.savedate?resData.savedate.replace('T',' '):''
                // 时间段列表
                this.dateTableList = resData.msgsolt
                let nodeList = []
                let tableData01 = []
                if(!this.isNull(resData.msgsolt)){
                    // for (let i = 0; i < resData.msgsolt.length; i++) {
                    //     const element01 = resData.msgsolt[i];
                    //     let elementNode01 = element01.Name.split('-')
                    //     nodeList = nodeList.concat(elementNode01)
                    // }
                    // // 时间点列表
                    // this.timeNodeList = [...new Set(nodeList)]
                    // 修改返回的数据格式方便排期表格展示
                    for (let h = 0; h < resData.msgsolt.length; h++) {
                        const element02 = resData.msgsolt[h];
                        tableData01.push(
                            {
                                StrIsCheck0: '',
                                Strtimeslot: ''
                            }
                        )
                        for (let j = 0; j < resData.msgheard.length; j++) {
                            const element03 = resData.msgheard[j];
                            // 给表头设置StrCloumid，方便与值匹配
                            this.$set(element03, "StrCloumid", 'StrIsCheck'+[j])
                            for (let k = 0; k < resData.msg.length; k++) {
                                const element04 = resData.msg[k];
                                // console.log('ppp', element04)
                                if(element02.Name == element04.Strtimeslot && (element03.StrtimeDate == element04.StrtimeDate)){
                                    this.$set(tableData01[h], "Strtimeslot", element02.Name)
                                    this.$set(tableData01[h], "StrIsCheck"+[j], element04.StrIsCheck)
                                }
                            }
                        }
                    }
                }
                // 表头
                this.tableTitle = resData.msgheard
                // 表格数据
                this.tableData = tableData01
                // console.log('kjj', this.termList)
            }
            this.dateLoading = false
        })
    },
    // 查看招聘计划详情
    getRecruitDtl(){
        // this.planQuery.GdrecpId = '25bfb26b-fcdd-4b2d-bb9a-07bb4f2e74c6'
        xz.getRecruitPlanDetail(this.planQuery.GdrecpId).then(res => {
            if(!this.isNull(res)){
                let results = JSON.parse(res)
                this.gapList = []
                this.depUserList = []
                // console.log('GdrecpId', results)
                if (results.status == 'ok') {
                    if(!this.isNull(results.msg)){
                        let msgdata = JSON.parse(results.msg)
                        this.planQuery = {
                            GdrecpId: msgdata.GdrecpId, // 计划id
                            Projectid: msgdata.Projectid, // 项目id
                            Jobid: msgdata.Jobid, // 岗位ID
                            StrDateterm: msgdata.StrDateterm, // 招聘期限
                            StrRemark: msgdata.StrRemark, // 备注（目前无）
                            GduserId: msgdata.GduserId,       
                            GduserName: msgdata.GduserName, // 登录人姓名
                            StrIsredate: msgdata.StrIsredate, // 是否重复排期 是 否
                            StrPlanstatus: '' // 计划状态 
                        }
                        if(msgdata.StrDateterm != '长期有效'){
                            this.isLongCheck = false
                            this.recruitDate = !this.isNull(msgdata.StrDateterm)?msgdata.StrDateterm.split(','):[]
                        }else{
                            this.isLongCheck = true
                        }
                        msgdata.StrIsredate == '是' ? this.isRepeatCheck = true : this.isRepeatCheck = false
                        if(msgdata.StrIsredate == '是'){
                            this.termQuery.datetype = '是'
                        }else{
                            this.termQuery.datetype = '否'
                        }
                    }
                    // 获取招聘排期
                    this.getTermData()
                    // 缺口记录
                    if(!this.isNull(results.msggapre)){
                        let msggapre = JSON.parse(results.msggapre)
                        for (let i = 0; i < msggapre.length; i++) {
                            const elementGap = msggapre[i];
                            this.gapList.push(
                                {
                                    StrgapNum: elementGap.StrgapNum, // 缺口数量
                                    StrgapCont: elementGap.StrgapCont, // 缺口内容
                                    StrEnclosure: elementGap.StrEnclosure,
                                    StrEnclosureName: '',
                                    updateTime: elementGap.DtInserDate
                                }
                            )
                        }
                    }
                    // 部门/顾问列表
                    if(!this.isNull(results.msgdepusernew)){
                        // let msgdepuser = results.msgdepuser
                        this.depUserList = results.msgdepusernew
                    }
                    // console.log('kk',this.depUserList)
                }
            }
            
        })
    },
    // 删除数据
    dltDAtaHandle(data,index){
        data.splice(index, 1)
    },
    // 复制链接
    repeatHandle(){
        // 后台传回的链接
        let url = 'https://dev.joball.net'
        navigator.clipboard.writeText(url).then(() => {
            this.$message.success('复制成功')
        })
    },
    // 查看附件下载
    detailEnclosure(){
        let url = this.docPath + this.postQuery.interviewAddressUrl
        this.download(url)
    },
    // 下载附件
    downloadFile(url){
        let path = this.docPath + url
        this.download(path)
    },
    download(url) {
        // console.log('url',url)
        const link = document.createElement('a')
        // a.download = name
        link.href = url
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
    // 获取岗位信息
    getPostInfo(){
        // this.planQuery.Jobid = '633240d3-8372-42c2-b546-b5f1584a4aac'
        xz.getjobdetails(this.planQuery.Jobid).then(res => {
            if(!this.isNull(res)){
                let results = JSON.parse(res)
                // console.log('postId', results)
                if (results.status == 'ok') {
                    this.postQuery = {
                        postId: results.data.Id, // 岗位id
                        ProjectId: results.data.ProjectId,
                        jobType: results.data.JobCategory, // 岗位类别
                        customerJobName: results.data.CustomerJobName, // 企业客户岗位名称
                        interviewAddress: results.data.InterviewAddress, // 面试地址
                        interviewAddressUrl: results.data.InterviewAddressUrl, // 面试地址详情附件
                        lng: results.data.Lng, // 经纬
                        lat: results.data.Lat // 纬度
                    }
                    this.provinceName = results.data.InterviewProvinceName
                    this.cityName = results.data.InterviewCityName
                    this.areaName = results.data.InterviewAraeName
                    this.planQuery.Projectid = results.data.ProjectId
                }
            }
            
        })
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
    }
  }
}
</script>
<style>
.p_demand_plan .el-table .el-table__cell{
    padding: 3px 0;
}
.p_demand_plan .el-date-editor.el-input__inner{
    width: 300px!important;
}
.date_table02{
    width: 100%;
    color:#fff;
}
.p_demand_plan .el-checkbox__inner{
    border-radius: 50%;
}
.p_demand_plan .date_table01.el-table--border .el-table__cell{
    background:#545c64;
    color:#fff;
}
.p_demand_plan .date_table02.el-table--enable-row-hover .el-table__body-wrapper .el-table__body tr:hover>td.el-table__cell{
    background-color: #fff;
    cursor: pointer;
}
.p_demand_plan .date_table01.el-table--enable-row-hover .el-table__body-wrapper .el-table__body tr:hover>td.el-table__cell{
    background-color: #545c64;
    color:#fff;
}
.p_demand_plan .date_table02 .el-table__body-wrapper .el-table__body td.el-table__cell,
.p_demand_plan .date_table02 .el-table__body-wrapper .cell{
    padding: 0;
}
.p_demand_plan .date_table02 .el-table__body-wrapper .term_cell{
    padding: 0;
}
.plan_input02.el-select{
    width: 300px;
    margin-right: 10px;
}
.p_plan_form01 .el-cascader{
    width: 300px;
}
.p_checkbox .el-checkbox__label{
    color:#f56c6c;
    font-weight: bold;
}
.cell_active{
    background-color: #19bd92;
    color:#19bd92;
}
.cell_nonactive{
    background-color: #fff;
    color:#fff;
}
.plan_table .el-table .el-table__cell{
    padding: 0;
}
.plan_table .el-table .cell,
.plan_table .el-table--border .el-table__cell:first-child .cell,
.plan_table .el-table th.el-table__cell>.cell{
    padding: 0;
}
</style>
<style scoped>
.date_table_txt{
    color:#fff;
    background:#545c64;
}
/* //阻止内容被选中 */
#timetable{ 
 -webkit-touch-callout:none; /*系统默认菜单被禁用*/ 
 -webkit-user-select:none; /*webkit浏览器*/ 
 -khtml-user-select:none; /*早期浏览器*/ 
 -moz-user-select:none;/*火狐*/ 
 -ms-user-select:none; /*IE10*/ 
 user-select:none; 
}
.p_plan_form03{
    margin-top: 10px;
}
.p_dtl_txt{
    font-size: 14px;
    color:#999;
    margin-bottom: 10px;
}
.d_txt{
    margin-left:6px;
    color:#67C23A;
    font-size:13px;
    cursor:pointer;
    text-decoration-line: underline;
}
.p_interview_right{
    flex: 1;
}
.p_interview_box{
    /* height: 500px; */
    overflow-y: auto;
}
.p_demand_plan .txt06{
    color:#999;
}
.p_demand_plan .el-icon-close{
    font-size: 16px;
    color:#999;
    cursor: pointer;
    margin-left: 10px;
}
.note_form:before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.p_plan_btns{
    display: flex;
    justify-content: center;
    margin: 30px 0;
}
.p_plan_type{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.p_plan_form01{
    margin-top: 10px;
}
.p_checkbox{
    display: flex;
    margin-top: 10px;
}
.p_plan_type .type_item{
    display: flex;
    align-items: center;
    margin-left: 20px;
}
.p_plan_type .type01{
    width: 40px;
    height: 15px;
    background-color: #fff;
    color:#999;
    font-size: 13px;
    border: 1px solid #ddd;
    margin-right: 8px;
}
.p_plan_type .type02{
    background-color: #19bd92;
    border: 1px solid #19bd92;
}
.p_interview_left ul{
    width: 50px;
    text-align: center;
}
.p_interview_left li{
    font-size: 13px;
    margin-top: 4px;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 20px;
}
.p_interview_left li:first-child{
    margin-top: 14px;
}
.p_interview_box{
    /* display: flex; */
    margin: 10px 0;
}
.p_plan_item{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
}
.p_plan_right{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.p_demand_plan .p_plan_title{
    margin-right: 12px;
    color:#999;
}
.p_plan_right .qrcode_img01{
    width: 25px;
    height: 25px;
    margin-left: 5px;
}
.qrcode_img02{
    width: 200px;
    height: 200px;
    margin-bottom: 5px;
}
.p_plan_right .txt01{
    color:#409EFF;
    font-size: 13px;
    margin-left: 20px;
    cursor: pointer;
}
.qrcode_box .txt02{
    color:#333;
    font-size: 14px;
    text-align: center;
    margin: 5px 0;
}
.p_plan_line{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.plan_form_list{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.plan_form_list .p_plan_item{
    margin-right: 20px;
    margin-bottom: 10px;
}
.p_plan_line .p_plan_item{
    margin-right: 50px;
    margin-bottom: 10px;
}
.p_plan_upload{
    display: flex;
    align-items: baseline;
}
.plan_input01{
    width: 100px;
}
.p_plan_record{
    width: 100%;
    font-size: 14px;
    color:#333;
    margin-bottom: 10px;
}
.p_plan_record .item_icon{
    color:#67C23A;
    font-size: 16px;
    margin-right: 6px;
}
.p_demand_plan .txt03{
    font-size: 14px;
    text-align: right;
    margin-bottom: 10px;
}
.p_demand_plan .txt04{
    font-size: 14px;
    color:#999;
    margin-right: 20px;
}
.p_demand_plan .add_txt{
    font-size: 14px;
    color:#333;
    margin: 0 0 10px;
}
.p_demand_plan .add_txt i{
    font-size: 15px;
    color:#999;
    margin-left: 10px;
}
.p_demand_plan .add_txt .txt07{
    font-size: 13px;
    color:#409eff;
    margin-left: 6px;
    cursor: pointer;
}
</style>